export { default as containerTemplate } from './container.dot';



// WEBPACK FOOTER //
// ./default-modules/root-container/templates/index.ts